var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarCardBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "solar:card-bold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_295_806654",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 19,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 3.5H8.75C5.45037 3.5 3.80012 3.5 2.7755 4.5255C2.037 5.26312 1.8305 6.32537 1.77275 8.09375H19.2272C19.1695 6.32537 18.963 5.26312 18.2245 4.5255C17.1999 3.5 15.5496 3.5 12.25 3.5ZM8.75 17.5H12.25C15.5496 17.5 17.1999 17.5 18.2245 16.4745C19.25 15.4499 19.25 13.7996 19.25 10.5C19.25 10.1132 19.25 9.74925 19.2482 9.40625H1.75175C1.75 9.74925 1.75 10.1132 1.75 10.5C1.75 13.7996 1.75 15.4499 2.7755 16.4745C3.80012 17.5 5.45037 17.5 8.75 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59375 14C4.59375 13.826 4.66289 13.659 4.78596 13.536C4.90903 13.4129 5.07595 13.3438 5.25 13.3438H8.75C8.92405 13.3438 9.09097 13.4129 9.21404 13.536C9.33711 13.659 9.40625 13.826 9.40625 14C9.40625 14.174 9.33711 14.341 9.21404 14.464C9.09097 14.5871 8.92405 14.6562 8.75 14.6562H5.25C5.07595 14.6562 4.90903 14.5871 4.78596 14.464C4.66289 14.341 4.59375 14.174 4.59375 14ZM10.2813 14C10.2813 13.826 10.3504 13.659 10.4735 13.536C10.5965 13.4129 10.7635 13.3438 10.9375 13.3438H12.25C12.424 13.3438 12.591 13.4129 12.714 13.536C12.8371 13.659 12.9063 13.826 12.9063 14C12.9063 14.174 12.8371 14.341 12.714 14.464C12.591 14.5871 12.424 14.6562 12.25 14.6562H10.9375C10.7635 14.6562 10.5965 14.5871 10.4735 14.464C10.3504 14.341 10.2813 14.174 10.2813 14Z",
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_295_806654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 0H21V21H0V0Z",
    fill: "#F36337"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCardBold);
export default __webpack_public_path__ + "static/media/solar_card-bold.87b64b2a55cd87ff0eab486ceeb6ca52.svg";
export { ForwardRef as ReactComponent };